import activityService from './activity.service'

class ActivitiesService {
  handleActivityFeedScroll (thresholdMultiplier) {
    const feedHeader = document.querySelector('.labels-list-anchor')
    const feedContent = document.getElementById('activity-menu-scrollable')
    if (!feedHeader) return
      
    const { top } = feedHeader.getBoundingClientRect()
    const positiveTop = -(top)
    if (feedContent.scrollHeight * thresholdMultiplier - positiveTop < 0) {
      activityService.getActivities()
    }
  }
}

export default new ActivitiesService()
